var _mask, _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMap(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_0_1",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.375 6.25C9.72018 6.25 10 5.97018 10 5.625C10 5.27982 9.72018 5 9.375 5C9.02982 5 8.75 5.27982 8.75 5.625C8.75 5.97018 9.02982 6.25 9.375 6.25Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.375 6.25C9.72018 6.25 10 5.97018 10 5.625C10 5.27982 9.72018 5 9.375 5C9.02982 5 8.75 5.27982 8.75 5.625C8.75 5.97018 9.02982 6.25 9.375 6.25Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.75 5.625C8.75 5.27982 9.02982 5 9.375 5V7.5C10.4105 7.5 11.25 6.66053 11.25 5.625H8.75ZM9.375 5C9.72018 5 10 5.27982 10 5.625H7.5C7.5 6.66053 8.33947 7.5 9.375 7.5V5ZM10 5.625C10 5.97018 9.72018 6.25 9.375 6.25V3.75C8.33947 3.75 7.5 4.58947 7.5 5.625H10ZM9.375 6.25C9.02982 6.25 8.75 5.97018 8.75 5.625H11.25C11.25 4.58947 10.4105 3.75 9.375 3.75V6.25Z",
    fill: "currentColor",
    mask: "url(#path-1-inside-1_0_1)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.29381 0.0950018C5.47845 -0.0203943 5.70983 -0.0313876 5.90457 0.0659837L11.8411 3.03423L16.5438 0.0950018C16.7365 -0.0254157 16.9793 -0.0317918 17.178 0.0783492C17.3768 0.18849 17.5001 0.397798 17.5001 0.625001V12.5C17.5001 12.7155 17.389 12.9158 17.2063 13.03L12.2063 16.155C12.0202 16.2713 11.7866 16.2815 11.5911 16.1818L5.65958 13.1567L0.96097 16.152C0.768542 16.2747 0.524551 16.2827 0.324463 16.173C0.124374 16.0633 -1.19208e-06 15.8532 0 15.625L6.07967e-05 3.75C6.19292e-05 3.5345 0.111074 3.33421 0.293811 3.22L5.29381 0.0950018ZM5.65907 1.34078L1.25006 4.09641L1.25001 14.4854L5.28909 11.9105C5.47586 11.7914 5.7117 11.7801 5.90901 11.8807L11.8438 14.9075L16.2501 12.1536V1.75266L12.2063 4.28C12.0217 4.3954 11.7903 4.40639 11.5956 4.30902L5.65907 1.34078Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 12.5V0.625001H6.25V12.5H5Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.25 15V3.75H12.5V15H11.25Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMap);
export default __webpack_public_path__ + "static/media/Map.ddc0188a.svg";
export { ForwardRef as ReactComponent };